import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Image, KeyboardAvoidingView, Platform, StyleSheet, TextInput, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { TouchableOpacity } from 'react-native-gesture-handler'

import { Palette } from '@ppwr/poker'

import { DS } from '../../design-system'
import { translate } from '../../i18n'
import { useStore } from '../../models'
import { Route, useLocalSearchParams, useRouter } from 'expo-router'
import { defaultBreakPoints, isWeb } from '@/components/WebWrapper'
import { useMutation } from '@tanstack/react-query'
import { useThrottledCallback } from 'use-debounce'
import { LoaderSpinner } from '@/components/LoaderSpinner'

export const ChangeNameScreen = observer(() => {
  const router = useRouter()
  const { onBack } = useLocalSearchParams<{ onBack: Route }>()
  const [userName, setUserName] = useState<string>('')
  const store = useStore()

  const createAccountMutation = useMutation({
    mutationFn: async () => {
      //const payload = {
        //isUserFromLiveEvent: true
      //}
      const isUsernameTaken = await store.session.checkIsUsernameTaken(userName)
      if (isUsernameTaken) {
        throw new Error(`The username ${userName} is already taken`)
      }
      await store.session.updateUserNameOnAppAndWordpress(userName)
      //await store.session.updateUserInfo(payload)
      await store.session.updateUserNameAndAnalytics(userName)
    },
    onSuccess(data, variables, context) {
      router.navigate('/onboarding/create-avatar')
    },
    onError(error, variables, context) {
      console.error('createAccountMutation:', error)
    }
  })
  const handleCreateAccount = useThrottledCallback(async () => createAccountMutation.mutateAsync(), 350, {
    leading: true
  })

  //where are you screen no longer active in flow
  //the screen preceding is auth and user should not be able to go back
  //const onPressBack = () => {
    //if (router.canGoBack()) {
      //return router.back()
    //}
    //router.replace('/onboarding/where-are-you')
  //}

  useEffect(() => {
    if (store.session.user) {
      const playerName = store.session.user?.name ?? 'placeholder'
      if (!playerName.includes('placeholder')) {
        playerName && setUserName(playerName)
      }
    }
  }, [store.session.user])

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      keyboardVerticalOffset={Platform.OS === 'ios' ? 0 : 50}
      style={{ flex: 1 }}
    >
      <SafeAreaView style={{ backgroundColor: Palette['Brand/Cream'], flexGrow: 1 }}>
        <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} />
        <View style={styles.webContainer}>
          <DS.Frame style={styles.container}>
            <DS.Frame style={styles.mainContent}>
              {/* <DS.Frame style={{ marginTop: 16 }}>
                <TouchableOpacity onPress={onPressBack}>
                  <Image
                    style={{ height: 24, width: 24 }}
                    source={require('../../../assets/userInfo/back.png')}
                    resizeMode="contain"
                  />
                </TouchableOpacity>
              </DS.Frame> */}
              <DS.Frame gap="32">
                <DS.Frame gap="4">
                  <View style={{ paddingTop: 16 }}>
                    <DS.Text variant="Heading 2/Regular" textAlign="center">
                      {/* {translate('memberForm.pokerNameQuestion')} */}
                      Create your profile
                    </DS.Text>
                  </View>
                  <DS.Text color="Brand/Dark Grey" variant="Body Medium/Regular" textAlign="center">
                    {translate('memberForm.pokerNamesubtitle')}
                  </DS.Text>
                </DS.Frame>
                <DS.Frame gap="4">
                  <DS.Frame style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                    <DS.Text variant="Body Medium/Medium">{translate('memberForm.name')}</DS.Text>
                    <DS.Text
                      variant="Body Small/Regular"
                      color={userName?.length > 15 ? 'Utility/Warning' : 'Global/Black'}
                    >
                      {userName?.length}/15
                    </DS.Text>
                  </DS.Frame>
                  <TextInput
                    value={userName}
                    onChangeText={setUserName}
                    style={[
                      styles.nameInput,
                      { borderColor: userName.length > 15 ? Palette['Utility/Warning'] : Palette['Global/Black'] }
                    ]}
                    placeholder="Enter a name"
                    placeholderTextColor={Palette['Brand/Dark Grey']}
                    allowFontScaling={false}
                    autoCapitalize={'words'}
                    autoCorrect={false}
                    maxLength={15}
                    autoComplete="off"
                    autoFocus={true}
                  />
                  <DS.Text variant="Body Small/Regular" color={'Utility/Warning'}>
                    {createAccountMutation.error?.message ?? ''}
                  </DS.Text>
                </DS.Frame>
              </DS.Frame>
            </DS.Frame>
            <DS.Button
              onPress={handleCreateAccount}
              disabled={createAccountMutation.isPending || userName.length < 1 || userName.length > 15}
              variant="Large/Primary"
              type="On Light"
              rightIcon={createAccountMutation.isPending && <LoaderSpinner containerStyle={{}} />}
            >
              Next
            </DS.Button>
          </DS.Frame>
        </View>
      </SafeAreaView>
    </KeyboardAvoidingView>
  )
})

export const styles = StyleSheet.create({
  webContainer: {
    width: '100%',
    maxWidth: isWeb ? defaultBreakPoints.sm : undefined,
    marginHorizontal: isWeb ? 'auto' : undefined
  },
  container: {
    paddingHorizontal: 24,
    paddingBottom: 16,
    height: '100%',
    justifyContent: 'space-between',
    gap: 32
  },
  mainContent: {
    gap: 20
  },
  nameInput: {
    borderWidth: 1,
    borderRadius: 4,
    paddingVertical: 12,
    paddingHorizontal: 14
  }
})
